// src/components/PartnerSlider.js (ĐÃ CẬP NHẬT SỬ DỤNG URL)

import React from "react";
import "./styles.css";
// Dữ liệu logo đối tác (Vui lòng thay thế các URL placeholder này)
const partners = [
  {
    name: "Samsung",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f1/Samsung_logo_blue.png/1200px-Samsung_logo_blue.png",
  },
  {
    name: "Lotte",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/Lotte_Logo_%282017%29.svg/2560px-Lotte_Logo_%282017%29.svg.png",
  },
  {
    name: "Techcombank",
    logo: "https://upload.wikimedia.org/wikipedia/commons/7/7c/Techcombank_logo.png",
  },
  {
    name: "BIDV",
    logo: "https://static.wixstatic.com/media/9d8ed5_6a2d6616217b4addac30b98736e98774~mv2.jpg/v1/fill/w_980,h_490,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/9d8ed5_6a2d6616217b4addac30b98736e98774~mv2.jpg",
  },
  {
    name: "Viettel",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Viettel_logo_2021.svg/2560px-Viettel_logo_2021.svg.png",
  },
  {
    name: "ICT",
    logo: "https://danhbaict.vn/wp-content/uploads/2025/04/EVN-ICT.jpg",
  },
  {
    name: "FLC",
    logo: "https://cdn.haitrieu.com/wp-content/uploads/2022/01/Logo-FLC-Group-V.png",
  },
  {
    name: "Vinhomes",
    logo: "https://cdn.haitrieu.com/wp-content/uploads/2022/01/Logo-Vinhomes.png",
  },
  {
    name: "Daikin",
    logo: "https://mltc.com.vn/wp-content/uploads/2018/01/logo-daikin-1.png",
  },
  {
    name: "Panasonic",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Panasonic_logo_%28Blue%29.svg/2560px-Panasonic_logo_%28Blue%29.svg.png",
  },
];
// Số logo hiển thị trên mỗi slide
const LOGOS_PER_SLIDE = 4;
// Tính tổng số slides cần thiết
const TOTAL_SLIDES = Math.ceil(partners.length / LOGOS_PER_SLIDE);

const PartnerSlider = () => {
  // Để tạo hiệu ứng cuộn vô hạn, ta nhân đôi danh sách đối tác
  const doubledPartners = [...partners, ...partners];

  return (
    <section className="partners-section">
      <h3 className="partners__subtitle">ĐỐI TÁC CHIẾN LƯỢC</h3>

      <div className="slider-track-wrapper">
        {}
        <div className="slider-track">
          {doubledPartners.map((partner, index) => (
            <div key={index} className="partner-logo-item">
              {}
              <img
                src={partner.logo} // <-- ĐÃ SỬA
                alt={partner.name}
                className="partner-logo"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnerSlider;
